import { TeamBrand, UnmanagedTeam } from '../types/models'
import ModelBaseService from './model-base'
import { DataField } from '../util/data-field'
import { listsService } from '.'

class TeamBrandService extends ModelBaseService {
  protected modelName = 'team-brand'
  public get fields(): DataField[] {
    return [
      {
        key: 'name',
        label: 'Name',
        type: 'input',
        required: true,
      },
      {
        key: 'mascot',
        label: 'Mascot',
        type: 'input',
        required: true,
      },
      {
        key: 'gender',
        label: 'Gender',
        type: 'select',
        options: listsService.teamGenders,
      },
      {
        key: 'timezone',
        label: 'Timezone',
        type: 'select',
        options: listsService.timezones,
      },
    ]
  }
  getPrimaryBrandColor(teamBrand?: TeamBrand) {
    if (!teamBrand) {
      return null
    }

    return teamBrand.color1
  }

  getSwatches(team: TeamBrand | UnmanagedTeam | null | undefined): string[] {
    if (!team) {
      return []
    }

    const swatches = [team.color1, team.color2, team.color3, team.color4]
    return swatches.filter((it) => !!it) as string[]
  }
}

export default new TeamBrandService()
